import { useState } from "react";
import { useNavigate } from "react-router-dom";

const TrackServiceOrder = () => {
  const [orderId, setOrderId] = useState("");
  const navigate = useNavigate();

  const handleSearch = () => {
    if (orderId.trim()) {
      navigate(`/order?id=${orderId}`);
    }
  };

  return (
    <section className="w-full lg:px-21 md:px-10 py-5 px-4 overflow-hidden">
      <div className="relative w-full max-w-7xl mx-auto  bg-[#0064E0] rounded-3xl overflow-hidden flex items-center justify-center px-4 pt-6 pb-10 lg:py-25">
        <div className="absolute inset-0 pointer-events-none opacity-60">
          <div className="absolute w-89 h-89 bg-linear-to-b from-white/10 to-white/5 rounded-[25px_0px] -rotate-45 -top-42 -left-25"></div>
          <div className="absolute w-89 h-89 bg-linear-to-b from-white/10 to-white/5 rounded-[25px_0px] -rotate-45 -top-42 left-52"></div>
          <div className="absolute w-89 h-89 bg-linear-to-b from-white/10 to-white/5 rounded-[25px_0px] -rotate-45 -top-42 left-130"></div>
          <div className="absolute w-64 h-64 bg-linear-to-b from-white/10 to-white/5 rounded-[25px_0px] -rotate-45 -top-22 left-187"></div>

          <div className="absolute w-88 h-88 bg-linear-to-b from-white/10 to-white/5 rounded-[25px_0px] -rotate-45 top-34 -left-50"></div>
          <div className="absolute w-88 h-88 bg-linear-to-b from-white/10 to-white/5 rounded-[25px_0px] -rotate-45 top-34 left-26"></div>
          <div className="absolute w-88 h-88 bg-linear-to-b from-white/10 to-white/5 rounded-[25px_0px] -rotate-45 top-27 left-90"></div>
          <div className="absolute w-88 h-88 bg-linear-to-b from-white/10 to-white/5 rounded-[25px_0px] -rotate-45 top-52 left-200"></div>
        </div>

        <div className="relative z-10 flex flex-col items-center text-center gap-8 w-full">
          <div className="flex flex-col gap-6">
            <h2 className="text-white font-semibold text-3xl md:text-4xl lg:text-5xl leading-tight">
              Ready to track your service order?
            </h2>
            <p className="text-white font-normal text-base md:text-lg lg:text-xl opacity-90">
              Start tracking your order now and experience seamless service
              management
            </p>
          </div>

          <div className="flex flex-col md:flex-row gap-6 max-w-xl w-full">
            <input
              type="text"
              placeholder="Enter your order ID"
              value={orderId}
              onChange={(e) => setOrderId(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleSearch()}
              className="flex-1 px-4 py-3.5 rounded-lg border border-gray-300 text-gray-900 focus:outline-none bg-white"
            />
            <button
              onClick={handleSearch}
              className="bg-white text-blue-600 px-12 py-3.5 rounded-xl font-medium text-base cursor-pointer"
            >
              Confirm
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrackServiceOrder;
